import CreateClientForm from "@/components/Forms/CreateClientForm";

const DashboardAllClientsCreate = () => {
  return <CreateClientForm create={true} />;
};

export default DashboardAllClientsCreate;
